<template>
  <div>
    <ApprovalProcess ref="ApprovalProcess" v-on:drawComplete="drawApprovalProcessComplete"></ApprovalProcess>
    <ApprovalProcess ref="TagApprovalProcess" v-on:drawComplete="drawApprovalProcessComplete" :tag-list="processUserTagList" tag-name="项目角色"></ApprovalProcess>
    <Modal title="租户管理" v-model="moduleReleaseProcessModal" :mask-closable="false" width="1000">
      <Form :model="process" ref="process" :label-width="120" :rules="processRules">
        <Row>
          <Col :md="24" :lg="12">
            <FormItem label="项目经理" style="width: 100%" prop="masters" :label-width="80">
              <Select v-model="process.masters" multiple placeholder="选择项目经理" filterable transfer>
                <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :md="24" :lg="12">
            <FormItem label="开发人员" style="width: 100%" prop="developers" :label-width="80">
              <Select v-model="process.developers" multiple placeholder="选择开发人员" filterable transfer>
                <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="24" :lg="12">
            <FormItem label="产品经理" style="width: 100%" prop="pms" :label-width="80">
              <Select v-model="process.pms" multiple placeholder="选择产品经理" filterable transfer>
                <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :md="24" :lg="12">
            <FormItem label="测试人员" style="width: 100%" prop="tests" :label-width="80">
              <Select v-model="process.tests" multiple placeholder="选择测试人员" filterable transfer>
                <Option v-for="item in testUserList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="24" :lg="12">
            <FormItem label="运维人员" style="width: 100%" prop="maintain" :label-width="80">
              <Select v-model="process.maintain" multiple placeholder="选择运维人员" filterable transfer>
                <Option v-for="item in maintainUserList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="模块申请审批流程">
          <Button style="margin-right: 5px" size="small" ghost type="success"
                  :class="(process.process && Object.keys(process.process).length > 0) ? '' : 'draw-process-btn-inactive'"
                  @click="openDrawApprovalProcessModal(process.process, ['process', 'process'])"
                  :icon="(process.process && Object.keys(process.process).length > 0) ? 'md-checkmark' : ''">制定流程</Button>
          <Button ghost type="error" size="small" @click="clearApprovalProcess(['process', 'process'])"
                  :class="!process.process ? '' : 'draw-process-btn-inactive'"
                  :icon="!process.process ? 'md-checkmark' : ''">无需审批</Button>
          <ApprovalSteps :process="process.process" style="margin-top: 25px"></ApprovalSteps>
        </FormItem>
        <FormItem label="成员变更审批流程">
          <Button style="margin-right: 5px" size="small" ghost type="success"
                  :class="(process.member_change_process && Object.keys(process.member_change_process).length > 0) ? '' : 'draw-process-btn-inactive'"
                  @click="openDrawTagApprovalProcessModal(process.member_change_process, ['process', 'member_change_process'])"
                  :icon="(process.member_change_process && Object.keys(process.member_change_process).length > 0) ? 'md-checkmark' : ''">制定流程</Button>
          <Button ghost type="error" size="small" @click="clearApprovalProcess(['process', 'member_change_process'])"
                  :class="!process.member_change_process ? '' : 'draw-process-btn-inactive'"
                  :icon="!process.member_change_process ? 'md-checkmark' : ''">无需审批</Button>
          <ApprovalSteps :process="process.member_change_process" style="margin-top: 25px"></ApprovalSteps>
        </FormItem>
        <FormItem label="代码发布审批流程">
          <Button style="margin-right: 5px" size="small" ghost type="success"
                  :class="(process.code_release_process && Object.keys(process.code_release_process).length > 0) ? '' : 'draw-process-btn-inactive'"
                  @click="openDrawTagApprovalProcessModal(process.code_release_process, ['process', 'code_release_process'])"
                  :icon="(process.code_release_process && Object.keys(process.code_release_process).length > 0) ? 'md-checkmark' : ''">制定流程</Button>
          <Button ghost type="error" size="small" @click="clearApprovalProcess(['process', 'code_release_process'])"
                  :class="!process.code_release_process ? '' : 'draw-process-btn-inactive'"
                  :icon="!process.code_release_process ? 'md-checkmark' : ''">无需审批</Button>
          <ApprovalSteps :process="process.code_release_process" style="margin-top: 25px"></ApprovalSteps>
        </FormItem>
        <FormItem label="数据库变更审批流程">
          <Button style="margin-right: 5px" size="small" ghost type="success"
                  :class="(process.db_release_process && Object.keys(process.db_release_process).length > 0) ? '' : 'draw-process-btn-inactive'"
                  @click="openDrawTagApprovalProcessModal(process.db_release_process, ['process', 'db_release_process'])"
                  :icon="(process.db_release_process && Object.keys(process.db_release_process).length > 0) ? 'md-checkmark' : ''">制定流程</Button>
          <Button ghost type="error" size="small" @click="clearApprovalProcess(['process', 'db_release_process'])"
                  :class="!process.db_release_process ? '' : 'draw-process-btn-inactive'"
                  :icon="!process.db_release_process ? 'md-checkmark' : ''">无需审批</Button>
          <ApprovalSteps :process="process.db_release_process" style="margin-top: 25px"></ApprovalSteps>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="moduleReleaseProcessDrawOk" :loading="moduleReleaseProcessSubmitting" :disabled="!canTenantRoleSaveDisabled">保存</Button>
        <Button @click="moduleReleaseProcessModal = false">取消</Button>
      </div>
    </Modal>
    <Card>
      <Row class="sm-pc-w100">
        <Col :md="22">
          <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
            <FormItem label="租户名">
              <Input v-model="tableSearchForm.name" style="min-width: 200px" />
            </FormItem>
            <FormItem label="关联用户">
              <Select v-model="tableSearchForm.users" placeholder="" filterable clearable transfer style="min-width: 200px">
                <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
              </Select>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTenantsList()">搜索</Button>
              <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="2" class="align-right">
          <Button style="float: right; " @click="change = true" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加租户</Button>
        </Col>
      </Row>
      <tables border search-place="bottom" v-model="tableData" :columns="columns"/>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getTenantsList"></page>
        </div>
      </div>
      <Drawer
        :title="changeTitle"
        v-model="change"
        width="692"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="70" :rules="ruleValidate">
          <form-item label="租户名称" prop="name">
            <Input v-model="formItem.name" placeholder=""/>
          </form-item>
          <form-item label="描述" prop="description">
            <Input v-model="formItem.description" placeholder="" :maxlength="128" :rows="4" type="textarea" />
          </form-item>
          <form-item label="关联用户" prop="users">
            <transfer
              :data="no_select_user"
              :target-keys="formItem.users"
              :list-style="listStyle"
              @on-change="userChange"
              filterable></transfer>
          </form-item>
          <form-item>
            <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
            <i-button style="margin-left: 8px" @click="change = false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import ApprovalProcess from '@/view/workflow/components/approval-process'
import ApprovalSteps from '@/view/workflow/components/approval-steps'
import { getTenants, changeTenant, deleteTenant, GetALLUsers } from '@/api/user'
import { getTenantRoles, modifyTenantRoles } from '@/api/workflow/tenant'
export default {
  name: 'tenant-manage',
  components: {
    Tables,
    ApprovalProcess,
    ApprovalSteps
  },
  data () {
    return {
      change: false,
      count: 1,
      size: 10,
      page: 1,
      changeTitle: '添加租户',
      columns: [
        // { title: 'ID', key: 'id', align: 'center', minWidth: 70 },
        { title: '租户名', key: 'name', align: 'center', minWidth: 100 },
        { title: '描述', key: 'description', align: 'center', minWidth: 200 },
        { title: '关联用户', key: 'users_name', align: 'center', minWidth: 500 },
        // { title: '描述', key: 'description', align: 'center', minWidth: 70 },
        {
          title: '操作',
          minWidth: 170,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.getModuleReleaseProcessData(params.row.id)
                  }
                }
              }, '管理'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                on: {
                  'on-ok': () => {
                    this.handleDelete(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      formItem: {
        id: 0,
        name: '',
        description: '',
        users: []
      },
      no_select_user: [],
      listStyle: {
        width: '265px',
        height: '300px'
      },
      ruleValidate: {
        name: [
          { required: true, message: '租户名称不能为空', trigger: 'blur' }
        ]
      },
      tableSearchForm: {
        name: '',
        users: ''
      },

      // 审批流程
      process: {},
      canTenantRoleSaveDisabled: false,
      processRules: {
        masters: { required: true, message: '请选择项目经理', type: 'array' },
        tests: { required: true, message: '请选择测试人员', type: 'array' },
        maintain: { required: true, message: '请选择运维人员', type: 'array' }
      },
      userList: [],
      maintainUserList: [],
      testUserList: [],
      moduleReleaseProcessModal: false,
      moduleReleaseProcessSubmitting: false,
      processUserTagList: ['项目经理', '产品经理', '开发人员', '测试人员', '运维人员']
    }
  },
  mounted: function () {
    this.getTenantsList()
    this.getNoSelectUser()
    this.getAllUserData()
  },
  methods: {
    edit (params) {
      this.formItem.id = params.row.id
      this.formItem.name = params.row.name
      this.formItem.description = params.row.description
      this.formItem.users = params.row.users
      this.change = true
    },
    handleSubmit (name) {
      let that = this.formItem
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          changeTenant(this.formItem, this.formItem.id).then(res => {
            this.$Notice.success({ title: '操作成功！' })
            that.id = 0
            that.name = ''
            that.users = []
            this.change = false
            this.getTenantsList()
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
        this.changeLoadingShow = false
      })
    },
    drawerClose () {
      let that = this.formItem
      that.id = 0
      that.name = ''
      that.users = []
    },
    handleDelete (params) {
      deleteTenant(params.row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTenantsList()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    getTenantsList (value = 1) {
      this.page = value
      let params = {
        size: this.size,
        page: this.page,
        name: this.tableSearchForm.name
      }
      if (this.tableSearchForm.users) {
        params.users = this.tableSearchForm.users
      }
      getTenants(params).then(res => {
        console.log(res.data.results)
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    getNoSelectUser () {
      let that = this
      that.no_select_user = []
      GetALLUsers().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_user.push({
              key: result[i].id,
              label: result[i].name ? result[i].name : result[i].username
            })
          }
        }
      })
    },
    userChange (newTargetKeys) {
      this.formItem.users = newTargetKeys
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: '',
        users: ''
      }
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
      GetALLUsers({group_name: '运维组'}).then(res => {
        this.maintainUserList = res.data
      })
      GetALLUsers({group_name: '测试组'}).then(res => {
        this.testUserList = res.data
      })
    },
    // 审批流程
    getModuleReleaseProcessData (id) {
      getTenantRoles(id).then(res => {
        if (res.data) {
          this.process = res.data
          this.canTenantRoleSaveDisabled = this.process.can_modify
        } else {
          this.process = {
            tenant: id,
            process: {},
            member_change_process: {},
            code_release_process: {},
            db_release_process: {},
            masters: [],
            developers: [],
            pms: [],
            tests: [],
            maintain: []
          }
          this.canTenantRoleSaveDisabled = this.$store.state.user.superuser
        }
        this.moduleReleaseProcessModal = true
      }).catch(res => {
        console.log(res.response)
        this.$Notice.error({title: '获取数据失败'})
      })
    },
    // 打开制定审批流程对话框
    openDrawApprovalProcessModal (process, callbackParams) {
      this.$refs.ApprovalProcess.openModal(JSON.parse(JSON.stringify(process)), callbackParams)
    },
    // 打开制定审批流程对话框
    openDrawTagApprovalProcessModal (process, callbackParams) {
      this.$refs.TagApprovalProcess.openModal(JSON.parse(JSON.stringify(process)), callbackParams)
    },
    // 制定审批流程完成
    drawApprovalProcessComplete (process, callbackParams) {
      this[callbackParams[0]][callbackParams[1]] = process
    },
    // 清空流程
    clearApprovalProcess (ob) {
      if (!this[ob[0]][ob[1]] || Object.keys(this[ob[0]][ob[1]]).length === 0) {
        this[ob[0]][ob[1]] = null
      } else {
        this.$Modal.confirm({
          title: '确认无需审批吗？',
          content: '<p>点击确定后将解绑该审批流程</p>',
          onOk: () => {
            this[ob[0]][ob[1]] = null
          }
        })
      }
    },
    // 提交审批流程
    moduleReleaseProcessDrawOk () {
      this.$refs.process.validate((valid) => {
        if (valid) {
          if (this.process.process) {
            if (Object.keys(this.process.process).length === 0) {
              this.$Notice.warning({title: '请制定[模块申请的审批流程]'})
              return
            }
          }
          if (this.process.member_change_process) {
            if (Object.keys(this.process.member_change_process).length === 0) {
              this.$Notice.warning({title: '请制定[成员变更的审批流程]'})
              return
            }
          }
          if (this.process.code_release_process) {
            if (Object.keys(this.process.code_release_process).length === 0) {
              this.$Notice.warning({title: '请制定[代码发布的审批流程]'})
              return
            }
          }
          if (this.process.db_release_process) {
            if (Object.keys(this.process.db_release_process).length === 0) {
              this.$Notice.warning({title: '请制定[数据库变更的审批流程]'})
              return
            }
          }
          this.moduleReleaseProcessSubmitting = true
          modifyTenantRoles(this.process, this.process.tenant).then(res => {
            this.$Notice.success({title: '保存成功'})
            this.moduleReleaseProcessModal = false
            this.moduleReleaseProcessSubmitting = false
          }).catch(res => {
            this.moduleReleaseProcessSubmitting = false
            console.log(res.response)
            this.$Notice.error({title: '保存失败'})
          })
        }
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
  .draw-process-btn-inactive {
    color: #999 !important;
    border-color: #999 !important;
  }
</style>
